import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import ReCAPTCHA from 'react-google-recaptcha'
import { post } from '../Accounts/API'

import LayerError from './LayerError'
import { contextualLayers, screeningCategories } from '../../config'
import Modal from './Modal'

export default () => {
    const [error, setError] = useState('')
    const [userType, setUserType] = useState(null)
    const [otherRole, setOtherRole] = useState('')
    const [userEmail, setUserEmail] = useState('')

    const active = useSelector(state => state.navigation.activeView)

    let layers = null
    if (active !== 'analyze') {
        if (active === 'explore') {
            layers = contextualLayers
        } else {
            layers = screeningCategories.map(({ fields }) => fields)
        }
    }

    // All layers that have errors
    const [errorLayers, setErrorLayers] = useState([{ layer: 'None', error: '' }])

    const [recaptchaValue, setRecaptchaValue] = useState(null)
    const [isLoading, setLoading] = useState(false)
    const [result, setResult] = useState(null)

    const canSubmit = recaptchaValue && [error, userType].some(item => !!item)

    const screenLayers = layers?.flat()

    let exploreLayers = []
    if (active === 'explore') {
        exploreLayers = Array.from(new Set(layers.map(({ category }) => category)))
    }

    const addLayer = () => {
        setErrorLayers(prevState => [...prevState, { layer: 'None', error: '' }])
    }

    const removeLayer = (index, value) => {
        setErrorLayers(prevState => prevState.filter(layer => prevState.indexOf(layer) != index))
    }

    const errorLayersMap = errorLayers.map((lyr, index) => {
        return (
            <React.Fragment key={Math.random()}>
                <LayerError
                    active={active}
                    exploreLayers={exploreLayers}
                    screenLayers={screenLayers}
                    layers={layers}
                    index={index}
                    removeLayer={removeLayer}
                    layer={lyr}
                    errorLayers={errorLayers}
                    setErrorLayers={setErrorLayers}
                />
            </React.Fragment>
        )
    })

    return (
        <Modal>
            <div className="feedback">
                <header>
                    <h2 className="title">Report an Error</h2>
                </header>
                <section>
                    {result !== null && (
                        <p>
                            {result === 'success'
                                ? 'Your error report has been submitted.'
                                : 'There was an error submitting your report. Please try again later.'}
                        </p>
                    )}
                    {result === null && (
                        <>
                            <div className="field">
                                <label className="label">
                                    <strong>How would you describe your role?</strong>
                                </label>

                                <div className="control">
                                    <div>
                                        <label className="radio">
                                            <input
                                                type="radio"
                                                checked={userType === 'DEVELOPER'}
                                                onChange={() => setUserType('DEVELOPER')}
                                            />{' '}
                                            Developer
                                        </label>
                                    </div>
                                    <div>
                                        <label className="radio">
                                            <input
                                                type="radio"
                                                checked={userType === 'PLANNER'}
                                                onChange={() => setUserType('PLANNER')}
                                            />{' '}
                                            Public/Private Sector Planner
                                        </label>
                                    </div>
                                    <div>
                                        <label className="radio">
                                            <input
                                                type="radio"
                                                checked={userType === 'OFFICIAL'}
                                                onChange={() => setUserType('OFFICIAL')}
                                            />{' '}
                                            Elected Official Staff
                                        </label>
                                    </div>
                                    <div>
                                        <label className="radio">
                                            <input
                                                type="radio"
                                                checked={userType === 'RESIDENT'}
                                                onChange={() => setUserType('RESIDENT')}
                                            />{' '}
                                            Resident
                                        </label>
                                    </div>
                                    <div>
                                        <label className="radio">
                                            <input
                                                type="radio"
                                                checked={userType === 'OTHER'}
                                                onChange={() => setUserType('OTHER')}
                                            />{' '}
                                            Other
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {userType === 'OTHER' ? (
                                <div className="field">
                                    <label className="label">
                                        <strong>Describe your role:</strong>
                                    </label>
                                    <input
                                        type="text"
                                        name="role-other"
                                        className="role-other"
                                        onChange={e => setOtherRole(e.target.value)}
                                    />
                                </div>
                            ) : (
                                ''
                            )}

                            {active !== 'analyze' ? (
                                <>
                                    <label className="label">
                                        <strong>What layer/s did you experience errors with?</strong>
                                    </label>

                                    <span>{errorLayersMap}</span>

                                    <div className="btn-container">
                                        <div className="add-btn" onClick={() => addLayer()}>
                                            + Add Layer
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className="field">
                                    <label className="label">
                                        <strong>Please describe the error or issue here:</strong>
                                    </label>
                                    <div className="control">
                                        <textarea
                                            className="textarea"
                                            style={{ minHeight: '100px' }}
                                            onChange={e => setError(e.target.value)}
                                            name="Analyze Error"
                                            value={error}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="field">
                                <label className="label">
                                    <strong>
                                        If you would like us to follow up with you, please share your email below
                                    </strong>{' '}
                                    <span className="optional">(Optional):</span>
                                </label>
                                <div className="control">
                                    <input
                                        type="email"
                                        name="email"
                                        className="email input"
                                        onChange={e => setUserEmail(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="field recaptcha" style={{ marginTop: '20px' }}>
                                <ReCAPTCHA
                                    sitekey={window.SETTINGS.recaptcha_key}
                                    onChange={value => setRecaptchaValue(value)}
                                />
                            </div>
                        </>
                    )}
                </section>
                <footer>
                    {result === null && (
                        <button
                            disabled={isLoading || !canSubmit}
                            className={`button is-primary ${isLoading ? 'is-loading' : ''}`}
                            type="submit"
                            onClick={() => {
                                setLoading(true)
                                post('/errors/', {
                                    tab: active,
                                    user_type: userType,
                                    other_role: otherRole,
                                    layer_errors: errorLayers.flat(),
                                    error,
                                    user_email: userEmail,
                                    recaptcha: recaptchaValue
                                })
                                    .then(() => {
                                        setLoading(false)
                                        setResult('success')
                                    })
                                    .catch(() => {
                                        setLoading(false)
                                        setResult('failure')
                                    })
                            }}
                            aria-label="Submit feedback"
                        >
                            SUBMIT
                        </button>
                    )}
                </footer>
            </div>
        </Modal>
    )
}
